// slideshow-enhancement.js
// Funktionsfähige Version mit automatischer Ersetzung

(function () {
  "use strict";

  console.log("🔍 Slideshow Enhancement Script loaded");

  let SlideshowEnhanced;

  function waitForSlideshow() {
    return new Promise((resolve) => {
      if (window.customElements && customElements.get("slideshow-component")) {
        resolve(customElements.get("slideshow-component"));
      } else {
        setTimeout(() => waitForSlideshow().then(resolve), 100);
      }
    });
  }

  function createEnhancedSlideshow(OriginalSlideshow) {
    return class extends OriginalSlideshow {
      constructor() {
        super();
        this.swiper = null;
        this.swiperEnabled = false;
        this.originalMethods = {};
        this.isInitialized = false;
        this._customPreviousIndex = 0; // Eigene Variable für previousIndex
      }

      async connectedCallback() {
        console.log("🔌 Enhanced slideshow connecting...", this);

        // Prüfe ob disabled
        if (
          this.hasAttribute("disabled") &&
          this.getAttribute("disabled") !== "false"
        ) {
          console.log(
            "⏸️ Slideshow is disabled, using original implementation"
          );
          await super.connectedCallback();
          return;
        }

        this.swiperEnabled = this.shouldUseSwiper();
        console.log("🎯 Swiper enabled:", this.swiperEnabled);

        if (this.swiperEnabled && typeof Swiper !== "undefined") {
          await this.initSwiperMode();
        } else {
          await super.connectedCallback();
        }

        this.isInitialized = true;
      }

      shouldUseSwiper() {
        console.log("🤔 Checking if should use Swiper...");

        const forceSwiper = this.dataset.useSwiper === "true";
       
        console.log("data-use-swiper:", this.dataset.useSwiper);
        console.log("force swiper:", forceSwiper);

        // WICHTIG: Prüfe ob das eine Nested Slideshow ist
        const isNestedSlideshow =
          this.closest(".swiper-slide") !== null ||
          this.closest("slideshow-slide") !== null ||
          this.closest(".resource-list__item") !== null;

        console.log("is nested slideshow:", isNestedSlideshow);

        if (isNestedSlideshow) {
          console.log(
            "❌ Skipping enhancement - this is a nested slideshow (product gallery)"
          );
          return false;
        }

        if (!forceSwiper) {
          console.log("❌ Swiper not requested");
          return false;
        }

        // Prüfe Slide-Anzahl
        const slideCount = this.getSlideCount();
        console.log("Total slide count:", slideCount);

        const shouldUse = slideCount >= 2;
        console.log("Should use Swiper:", shouldUse);

        return shouldUse;
      }

      async initSwiperMode() {
        try {
          console.log("🚀 Initializing Swiper mode...");

          // Original-Initialisierung zuerst
          console.log("📋 Calling super.connectedCallback()...");
          await super.connectedCallback();

          // Warte länger bis DOM vollständig stabilisiert ist
          console.log("⏳ Waiting for DOM to stabilize...");
          await new Promise((resolve) => setTimeout(resolve, 200));

          // Validiere dass Element noch verbunden ist
          if (!this.isConnected) {
            throw new Error("Element was disconnected during initialization");
          }

          console.log("🔧 Setting up Swiper...");
          await this.setupSwiper();
        } catch (error) {
          console.error("❌ Swiper initialization failed:", error);
          this.swiperEnabled = false;

          if (!this.isInitialized) {
            console.log("🔄 Falling back to original implementation...");
            await super.connectedCallback();
          }
        }
      }

      async setupSwiper() {
        console.log("🛠️ Setting up Swiper...");

        // Finde Scroller Element
        const originalScroller =
          this.refs?.scroller ||
          this.querySelector('[ref="scroller"]') ||
          this.querySelector("slideshow-slides");

        if (!originalScroller) {
          throw new Error("No scroller element found");
        }

        console.log("Original scroller:", originalScroller);

        // LÖSUNG: Erstelle Standard-DOM-Struktur für Swiper
        const swiperContainer = this.createSwiperDOMStructure(originalScroller);

        // Backup Original-Methoden
        this.backupOriginalMethods();

        // Swiper-Konfiguration
        const config = this.buildSwiperConfig();
        console.log("Swiper config:", config);

        try {
          console.log(
            "🎯 Creating Swiper instance with standard DOM structure"
          );

          this.swiper = new Swiper(swiperContainer, config);

          const initialSlide =
            parseInt(this.dataset.initialSlide) ||
            parseInt(this.getAttribute("initial-slide")) ||
            0;
          if (initialSlide > 0) {
            this.swiper.slideTo(initialSlide, 0);
          }

          console.log("✅ Swiper created successfully");
        } catch (error) {
          console.error("❌ Swiper creation failed:", error);
          this.swiperEnabled = false;
          this.restoreOriginalMethods();
          throw error;
        }
      }

      createSwiperDOMStructure(originalScroller) {
        console.log("🏗️ Creating standard DOM structure for Swiper...");

        // Finde nur DIREKTE Original-Slides (nicht nested)
        const originalSlides = this.findSlides(originalScroller);
        console.log(
          `Found ${originalSlides.length} direct slides (ignoring nested slideshows)`
        );

        if (originalSlides.length === 0) {
          throw new Error("No direct slides found for Swiper");
        }

        // Verstecke Original-Scroller
        originalScroller.style.display = "none";

        // Erstelle Standard-Swiper-Struktur
        const swiperContainer = document.createElement("div");
        swiperContainer.className = "swiper swiper-container-enhanced";

        const swiperWrapper = document.createElement("div");
        swiperWrapper.className = "swiper-wrapper";

        // Bestimme ob wir Slides duplizieren müssen für Loop
        const needsLoop = this.hasAttribute("infinite");
        const maxSlidesPerView = 5; // Maximum auf Desktop
        const minSlidesForLoop = maxSlidesPerView + 4; // +4 für sauberen Loop

        let slidesToAdd = [...originalSlides];
        let duplicationsNeeded = 1;

        // Dupliziere Slides falls nötig für Loop
        if (needsLoop && originalSlides.length < minSlidesForLoop) {
          duplicationsNeeded = Math.ceil(
            minSlidesForLoop / originalSlides.length
          );
          console.log(
            `🔄 Need ${duplicationsNeeded} duplications for smooth loop (${
              originalSlides.length
            } → ${duplicationsNeeded * originalSlides.length} slides)`
          );

          slidesToAdd = [];
          for (let i = 0; i < duplicationsNeeded; i++) {
            slidesToAdd.push(...originalSlides);
          }
        }

        // Erstelle Swiper Slides
        slidesToAdd.forEach((originalSlide, index) => {
          const swiperSlide = document.createElement("div");
          swiperSlide.className = "swiper-slide";

          // Kopiere gesamten Inhalt (inklusive nested slideshows)
          swiperSlide.innerHTML = originalSlide.innerHTML;

          // Kopiere wichtige Attribute
          const attributesToCopy = [
            "style",
            "slide-id",
            "aria-hidden",
            "data-slide-index",
          ];
          attributesToCopy.forEach((attr) => {
            if (originalSlide.hasAttribute(attr)) {
              swiperSlide.setAttribute(attr, originalSlide.getAttribute(attr));
            }
          });

          // Setze eindeutige IDs für Debug und Tracking
          const originalIndex = index % originalSlides.length;
          const duplicationGroup = Math.floor(index / originalSlides.length);

          swiperSlide.setAttribute("data-original-slide-index", originalIndex);
          swiperSlide.setAttribute("data-slide-duplicate", duplicationGroup);
          swiperSlide.setAttribute(
            "data-product-id",
            originalSlide.getAttribute("data-product-id") ||
              `product-${originalIndex}`
          );

          swiperWrapper.appendChild(swiperSlide);
          console.log(
            `✅ Created swiper slide ${
              index + 1
            } (duplicate ${duplicationGroup}, original ${originalIndex + 1})`
          );
        });

        swiperContainer.appendChild(swiperWrapper);

        // Füge Swiper-Container nach dem Original ein
        originalScroller.parentNode.insertBefore(
          swiperContainer,
          originalScroller.nextSibling
        );

        // Speichere Referenzen für Cleanup
        this.originalScroller = originalScroller;
        this.swiperContainer = swiperContainer;
        this.originalSlidesCount = originalSlides.length;
        this.totalSlidesCount = slidesToAdd.length;

        console.log(
          `✅ Standard DOM structure created with ${slidesToAdd.length} slides (${originalSlides.length} unique, ${duplicationsNeeded} duplications)`
        );
        return swiperContainer;
      }

      prepareContainerForSwiper(scroller) {
        console.log("🏗️ Preparing container for Swiper...");

        // Swiper-Klasse auf Container
        if (!scroller.classList.contains("swiper")) {
          scroller.classList.add("swiper");
          console.log("✅ Added swiper class to scroller");
        }

        // Finde und markiere Slides - OHNE DOM zu ändern
        const slides = this.findSlides(scroller);
        console.log(`🎯 Found ${slides.length} slides to prepare`);

        slides.forEach((slide, index) => {
          if (!slide.classList.contains("swiper-slide")) {
            slide.classList.add("swiper-slide");
            console.log(`✅ Added swiper-slide class to slide ${index}`);
          }
        });

        console.log(
          `🎯 Prepared ${slides.length} slides for Swiper - DOM structure unchanged`
        );
      }

      findSlides(container) {
        // KORRIGIERT: Suche in der richtigen Container-Struktur
        let slidesContainer = container;

        // Falls container das slideshow-component selbst ist, finde den slides container
        if (
          container.tagName === "SLIDESHOW-COMPONENT-ENHANCED" ||
          container.tagName === "SLIDESHOW-COMPONENT"
        ) {
          slidesContainer =
            container.querySelector('slideshow-slides[ref="scroller"]') ||
            container.querySelector("slideshow-slides");
        }

        if (!slidesContainer) {
          console.warn("❌ No slides container found");
          return [];
        }

        // Finde alle slideshow-slide Elemente im slides container
        const allSlides = Array.from(
          slidesContainer.querySelectorAll('slideshow-slide[ref*="slides"]')
        );

        // Filtere nur direkte Slides (gehören zu DIESEM slideshow, nicht zu nested ones)
        const directSlides = allSlides.filter((slide) => {
          // Prüfe ob das slide zu diesem slideshow gehört
          const parentSlideshow = slide.closest(
            "slideshow-component, slideshow-component-enhanced"
          );
          const belongsToThis = parentSlideshow === this;

          if (belongsToThis) {
            console.log(
              `✅ Found direct slide:`,
              slide.className,
              slide.style.viewTimelineName
            );
          } else {
            console.log(`⏭️ Skipping nested slide:`, slide.className);
          }

          return belongsToThis;
        });

        console.log(
          `🎯 Found ${directSlides.length} direct slides (${
            allSlides.length
          } total, ${allSlides.length - directSlides.length} nested skipped)`
        );
        return directSlides;
      }

      getSlideCount() {
        const slides = this.findSlides(this);
        return slides.length;
      }

      buildSwiperConfig() {
        const originalSlideCount =
          this.originalSlidesCount || this.getSlideCount();
        const totalSlideCount = this.totalSlidesCount || originalSlideCount;

        console.log(
          `Building Swiper config: ${originalSlideCount} unique slides, ${totalSlideCount} total slides`
        );

        // Mit duplizierten Slides können wir immer Loop aktivieren
        const enableLoop =
          this.hasAttribute("infinite") && totalSlideCount >= 8;

        console.log(
          `Loop enabled: ${enableLoop} (total slides: ${totalSlideCount})`
        );

        return {
          // Loop mit duplizierten Slides
          loop: enableLoop,
          loopAdditionalSlides: enableLoop ? 3 : 0,

          // Responsive Slides per View
          slidesPerView: 1.2, // Default Mobile - zeige teilweise nächsten Slide
          spaceBetween: 12,
          speed: 300,

          // Responsive Breakpoints
          breakpoints: {
            // Mobile: 1.2 Products (zeige teilweise nächsten)
            320: {
              slidesPerView: 1.2,
              spaceBetween: 12,
            },
            // Mobile Landscape: 2 Products
            480: {
              slidesPerView: 2,
              spaceBetween: 12,
            },
            // Tablet: 3 Products
            768: {
              slidesPerView: 3,
              spaceBetween: 16,
            },
            // Desktop Small: 4 Products
            1024: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            // Desktop Large: 5 Products
            1200: {
              slidesPerView: 5,
              spaceBetween: 20,
            },
          },

          // CSS Mode deaktivieren für bessere Performance
          cssMode: false,

          // Navigation
          navigation: this.getNavigationConfig(),
          pagination: this.getPaginationConfig(),
          autoplay: this.getAutoplayConfig(),

          // Touch & Mouse
          grabCursor: true,
          touchRatio: 1,

          // Wichtig für Loop: Centered slides für bessere Loop-Performance
          centeredSlides: false,

          // Events
          on: {
            init: (swiper) => this.handleSwiperInit(swiper),
            slideChange: (swiper) => this.handleSwiperSlideChange(swiper),
            transitionStart: () => this.setAttribute("transitioning", ""),
            transitionEnd: () => this.removeAttribute("transitioning"),

            // Loop-spezifische Events
            loopFix: (swiper) => {
              console.log("🔄 Loop fix triggered");
            },
          },
        };
      }

      getNavigationConfig() {
        const prevEl =
          this.refs?.previous ||
          this.querySelector("[data-slideshow-previous]") ||
          this.querySelector(".slideshow-arrow--previous");
        const nextEl =
          this.refs?.next ||
          this.querySelector("[data-slideshow-next]") ||
          this.querySelector(".slideshow-arrow--next");

        if (prevEl && nextEl) {
          return {
            prevEl: prevEl,
            nextEl: nextEl,
            disabledClass: "disabled",
          };
        }
        return false;
      }

      getPaginationConfig() {
        const paginationEl =
          this.refs?.dots?.[0] ||
          this.querySelector("[data-slideshow-pagination]") ||
          this.querySelector(".slideshow-dots") ||
          this.querySelector(".slideshow-pagination");

        if (paginationEl) {
          return {
            el: paginationEl,
            clickable: true,
            bulletClass: "dot",
            bulletActiveClass: "active",
          };
        }
        return false;
      }

      getAutoplayConfig() {
        const autoplayInterval = this.autoplayInterval;
        if (!autoplayInterval) return false;

        return {
          delay: autoplayInterval,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        };
      }

      handleSwiperSlideChange(swiper) {
        // Bei Loop-Mode verwende realIndex für echte Position
        const realIndex = swiper.realIndex;
        const originalSlidesCount = this.originalSlidesCount || 6;

        // Berechne echte Position im Original-Set
        const trueIndex = realIndex % originalSlidesCount;

        if (this.refs?.current) {
          this.refs.current.textContent = `${trueIndex + 1}`;
        }

        // Verwende eigene Variable für previousIndex
        const prevIndex = this._customPreviousIndex || 0;

        this.dispatchEvent(
          new CustomEvent("slideshow:change", {
            detail: {
              index: trueIndex, // Echte Position
              realIndex: realIndex, // Swiper realIndex
              previousIndex: prevIndex,
              slide: swiper.slides[swiper.activeIndex],
              totalSlides: originalSlidesCount,
            },
          })
        );

        // Speichere in eigener Variable
        this._customPreviousIndex = trueIndex;

        console.log(
          `📍 Slide changed: realIndex=${realIndex}, trueIndex=${trueIndex}`
        );
      }

      handleSwiperInit(swiper) {
        this.handleSwiperSlideChange(swiper);
      }

      backupOriginalMethods() {
        this.originalMethods = {
          select: super.select?.bind(this),
          next: super.next?.bind(this),
          previous: super.previous?.bind(this),
          play: super.play?.bind(this),
          pause: super.pause?.bind(this),
        };
      }

      restoreOriginalMethods() {
        Object.assign(this, this.originalMethods);
      }

      // Override Methods
      async select(input, event, options = {}) {
        if (!this.swiperEnabled || !this.swiper) {
          return super.select(input, event, options);
        }

        let slideIndex;
        if (typeof input === "number") {
          slideIndex = input;
        } else if (typeof input === "string") {
          slideIndex = parseInt(input, 10);
        }

        if (typeof slideIndex === "number" && !isNaN(slideIndex)) {
          const { animate = true } = options;
          this.swiper.slideTo(slideIndex, animate ? undefined : 0);
        }
      }

      next(event, options) {
        event?.preventDefault();

        if (this.swiperEnabled && this.swiper) {
          this.swiper.slideNext();
          return;
        }

        return super.next(event, options);
      }

      previous(event, options) {
        event?.preventDefault();

        if (this.swiperEnabled && this.swiper) {
          this.swiper.slidePrev();
          return;
        }

        return super.previous(event, options);
      }

      play(interval) {
        if (this.swiperEnabled && this.swiper?.autoplay) {
          this.swiper.autoplay.start();
          return;
        }

        return super.play(interval);
      }

      pause() {
        if (this.swiperEnabled && this.swiper?.autoplay) {
          this.swiper.autoplay.pause();
          return;
        }

        return super.pause();
      }

      get current() {
        if (this.swiperEnabled && this.swiper) {
          return this.swiper.realIndex;
        }

        return super.current;
      }

      set current(value) {
        if (this.swiperEnabled && this.swiper) {
          this.swiper.slideTo(value);
          return;
        }

        super.current = value;
      }

      disconnectedCallback() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }

        super.disconnectedCallback?.();
      }
    };
  }

  // AUTOMATISCHE ERSETZUNG - Nur für Top-Level Slideshows
  function replaceExistingSlideshows() {
    console.log("🔄 Replacing existing slideshows...");

    // Finde nur TOP-LEVEL Slideshows - nicht die in Product Cards
    const slideshowsToReplace = document.querySelectorAll(
      'slideshow-component[data-use-swiper="true"]:not([disabled="true"]), slideshow-component[infinite]:not([disabled="true"])'
    );

    // Filtere Nested Slideshows aus
    const topLevelSlideshows = Array.from(slideshowsToReplace).filter(
      (slideshow) => {
        const isNested =
          slideshow.closest(".swiper-slide") !== null ||
          slideshow.closest("slideshow-slide") !== null ||
          slideshow.closest(".resource-list__item") !== null ||
          slideshow.closest(".product-card") !== null;

        if (isNested) {
          console.log(
            "⏭️ Skipping nested slideshow (product gallery):",
            slideshow
          );
          return false;
        }

        return true;
      }
    );

    console.log(
      `📋 Found ${topLevelSlideshows.length} top-level slideshows to replace (${
        slideshowsToReplace.length
      } total, ${
        slideshowsToReplace.length - topLevelSlideshows.length
      } nested skipped)`
    );

    topLevelSlideshows.forEach((slideshow, index) => {
      try {
        console.log(
          `🔧 Replacing top-level slideshow ${index + 1}:`,
          slideshow
        );

        // Erstelle Enhanced Element
        const enhanced = document.createElement("slideshow-component-enhanced");

        // Kopiere alle Attribute
        Array.from(slideshow.attributes).forEach((attr) => {
          enhanced.setAttribute(attr.name, attr.value);
        });

        // Kopiere innerHTML
        enhanced.innerHTML = slideshow.innerHTML;

        // Ersetze das Element
        slideshow.parentNode.replaceChild(enhanced, slideshow);

        console.log(
          `✅ Successfully replaced top-level slideshow ${index + 1}`
        );
      } catch (error) {
        console.error(`❌ Failed to replace slideshow ${index + 1}:`, error);
      }
    });
  }

  async function initEnhancement() {
    console.log("🚀 Starting slideshow enhancement...");

    try {
      if (typeof Swiper === "undefined") {
        console.warn("⚠️ Swiper.js not found");
        return;
      }

      const OriginalSlideshow = await waitForSlideshow();
      SlideshowEnhanced = createEnhancedSlideshow(OriginalSlideshow);

      if (!customElements.get("slideshow-component-enhanced")) {
        customElements.define(
          "slideshow-component-enhanced",
          SlideshowEnhanced
        );
        console.log("✅ slideshow-component-enhanced registered");
      }

      // WICHTIG: Warte kurz und ersetze dann bestehende Slideshows
      setTimeout(() => {
        replaceExistingSlideshows();
      }, 500);

      console.log("🎉 Enhancement initialization complete");
    } catch (error) {
      console.error("❌ Enhancement failed:", error);
    }
  }

  function addEnhancementStyles() {
    const style = document.createElement("style");
    style.textContent = `
      /* Slideshow Enhancement - Product Carousel Responsive Styles */
      
      .swiper-container-enhanced {
        width: 100%;
        height: 100%;
        margin-left: auto;
        margin-right: auto;
        position: relative;
        overflow: hidden;
        list-style: none;
        padding: 0;
        z-index: 1;
      }
      
      .swiper-container-enhanced .swiper-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 1;
        display: flex;
        transition-property: transform;
        box-sizing: content-box;
      }
      
      .swiper-container-enhanced .swiper-slide {
        flex-shrink: 0;
        height: 100%;
        position: relative;
        transition-property: transform;
        box-sizing: border-box;
      }
      
      /* Slide Widths werden jetzt von Swiper breakpoints gesteuert, nicht CSS */
      /* Aber wir stellen sicher, dass Content richtig skaliert */
      
      slideshow-component-enhanced .swiper-button-disabled {
        opacity: 0.3;
        pointer-events: none;
      }
      
      slideshow-component-enhanced[transitioning] {
        pointer-events: none;
      }
      
      /* Product Content Sizing */
      .swiper-container-enhanced .swiper-slide .resource-list__item {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
      }
      
      .swiper-container-enhanced .swiper-slide .product-card {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
      }
      
      .swiper-container-enhanced .swiper-slide .product-card__content {
        flex: 1;
        display: flex;
        flex-direction: column;
      }
      
      /* Stelle sicher dass innere Slideshows nicht gestört werden */
      .swiper-container-enhanced .swiper-slide slideshow-component {
        /* Innere Slideshows behalten ihre original Styles */
      }
    `;
    document.head.appendChild(style);
  }

  // Helper Functions für manuelle Nutzung
  window.enhanceSlideshow = function (slideshowElement) {
    if (
      !slideshowElement ||
      slideshowElement.tagName !== "SLIDESHOW-COMPONENT"
    ) {
      console.warn("⚠️ Invalid slideshow element");
      return;
    }

    try {
      slideshowElement.dataset.useSwiper = "true";

      const enhanced = document.createElement("slideshow-component-enhanced");

      Array.from(slideshowElement.attributes).forEach((attr) => {
        enhanced.setAttribute(attr.name, attr.value);
      });

      enhanced.innerHTML = slideshowElement.innerHTML;
      slideshowElement.parentNode?.replaceChild(enhanced, slideshowElement);

      console.log("✅ Manual enhancement successful");
      return enhanced;
    } catch (error) {
      console.error("❌ Manual enhancement failed:", error);
      return null;
    }
  };

  window.replaceAllSlideshows = function () {
    replaceExistingSlideshows();
  };

  // Initialization
  
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      addEnhancementStyles();
      initEnhancement();
    });
  } else {
    addEnhancementStyles();
    initEnhancement();
  }

  // Shopify Theme Editor Support
  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    document.addEventListener("shopify:section:load", function () {
      setTimeout(() => {
        initEnhancement();
      }, 100);
    });
  }  
})();
